var _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-31 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m225 0-225 95.097656v83.300782c0 144.300781 86.101562 274.199218 219 331.199218l6 2.402344 6-2.402344c132.898438-57 219-186.898437 219-331.199218v-83.300782zm0 0",
    fill: "#6aa9ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m450 95.097656v83.300782c0 144.300781-86.101562 274.199218-219 331.199218l-6 2.402344v-512zm0 0",
    fill: "#4895ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m360 257c0 46.800781-23.699219 88.199219-60 112.199219h-15v-22.199219c0-33-27-60-60-60s-60 27-60 60v22.199219h-15c-36.300781-24-60-65.398438-60-112.199219 0-74.699219 60.300781-135 135-135s135 60.300781 135 135zm0 0",
    fill: "#61729b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m360 257c0 46.800781-23.699219 88.199219-60 112.199219h-15v-22.199219c0-33-27-60-60-60v-165c74.699219 0 135 60.300781 135 135zm0 0",
    fill: "#47568c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m225 182c-24.902344 0-45 20.097656-45 45s20.097656 45 45 45 45-20.097656 45-45-20.097656-45-45-45zm0 0",
    fill: "#e0f4ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m300 347v22.199219c-21.597656 14.398437-47.402344 22.800781-75 22.800781s-53.402344-8.402344-75-22.800781v-22.199219c0-41.398438 33.601562-75 75-75s75 33.601562 75 75zm0 0",
    fill: "#e0f4ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bbdcff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m225 272v-90c24.902344 0 45 20.097656 45 45s-20.097656 45-45 45zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 347v22.199219c-21.597656 14.398437-47.402344 22.800781-75 22.800781v-120c41.398438 0 75 33.601562 75 75zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.6981481130d99bdd121573908c8c72ac.svg";
export { ForwardRef as ReactComponent };